import { Link } from 'react-router-dom';
import { useT } from '../../i18n/index.ts';
import { Panel, buttonClass } from '../../ui/index.ts';

/**
 * The static rail: four destinations that stay useful even when every
 * data query on the page has failed. Routes are this console's own —
 * `/pricing` is the canonical URL, not the `/billing/pricing` alias
 * that only exists to keep console-web deep links resolving.
 */
export function QuickActions(props: {
  readonly canManageBilling: boolean;
  readonly canAccessApiKeys: boolean;
}): JSX.Element {
  const t = useT();
  return (
    <Panel caption={t('dashboard.quick.caption')} padded testId="dashboard-quick-actions">
      <div className="flex flex-wrap gap-2">
        {props.canAccessApiKeys ? (
          <Link
            to="/keys"
            className={buttonClass('secondary')}
            data-testid="dashboard-action-create-key"
          >
            {t('dashboard.quick.create_key')}
          </Link>
        ) : null}
        {props.canManageBilling ? (
          <Link
            to="/billing/topup"
            className={buttonClass('secondary')}
            data-testid="dashboard-action-top-up"
          >
            {t('dashboard.quick.topup')}
          </Link>
        ) : null}
        <Link
          to="/requests"
          className={buttonClass('secondary')}
          data-testid="dashboard-action-requests"
        >
          {t('dashboard.quick.requests')}
        </Link>
        <Link
          to="/pricing"
          className={buttonClass('secondary')}
          data-testid="dashboard-action-pricing"
        >
          {t('dashboard.quick.pricing')}
        </Link>
      </div>
    </Panel>
  );
}
